import React, { useEffect } from "react";
import { useHistory } from "react-router";
import { useGlobal } from "../global/user";
import { logOut, getCookie } from "../container/LoginHelper";
import { User } from "../api";
import Dashboard from "../api/dashboard";
import { Button } from "antd";
import { readCachedBranding } from "../context/brandingDefaults";

export default function Director() {
  const history = useHistory();
  const { user, setUser, setFields, setField, field, hasDashboard, setHasDashboard } = useGlobal();
  const logOutOpen = () => {
    // 記住所屬公司的登入網址，登出後回到該公司的品牌登入頁
    const slug = user?.branding?.slug;
    logOut();
    window.location.hash = `#/${slug || ""}`;
    window.location.reload();
  };
  const ToHistory = () => {
    history.push(`/history`);
  };
  const ToSetting = () => {
    history.push(`/setting`);
  };
  const ToDashboardConfig = () => {
    history.push(`/dashboard/config/${user.company_id}`);
  };
  const ToDashboardView = () => {
    history.push(`/dashboard/view/${user.company_id}`);
  };
  const handleOpenClose = () => {
    history.push(`/control`);
  };
  // 登入失效時回到品牌登入頁（品牌快取裡有該公司的網址代碼）
  const backToLogin = () => {
    const slug = user?.branding?.slug || readCachedBranding()?.slug;
    return `/${slug || ""}`;
  };
  useEffect(() => {
    const cookie = getCookie();
    if (cookie == null) {
      history.push(backToLogin());
      return;
    }
    (async () => {
      let res = await User.CheckToken(getCookie());
      if (res.code !== 200) {
        history.push(backToLogin());
      } else {
        setUser(res.data.userInfo);
        if (res.data.fields.length > 0) {
          setFields(res.data.fields);
          setField(res.data.fields[0].field_id);
        }
        const companyId = res.data.userInfo?.company_id;
        if (companyId) {
          try {
            const result = await Dashboard.CheckExists(companyId);
            setHasDashboard(result.exists);
          } catch (e) {
            console.warn("CheckExists failed", e);
          }
        }
      }
    })();
  }, []);

  const controlHeaderStyle = {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0px 0px",
    width: "100%",
    margin: "0",
    overflow: "hidden"
  };

  const controlButtonStyle = {
    flex: 1,
    height: "50px",
    minWidth: 0,
    margin: "0",
    fontSize: window.innerWidth <= 768 ? "0.9rem" : "1rem",
    fontWeight: "bold",
    textTransform: "none",
    background: "var(--button-background) !important",
    color: "var(--button-text) !important",
    border: `2px solid var(--button-border) !important`,
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    whiteSpace: "nowrap",
    transition: "all 0.3s ease"
  };

  return (
    <div style={controlHeaderStyle}>
      <Button style={controlButtonStyle} onClick={ToDashboardView} hidden={!hasDashboard || user.class > process.env.REACT_APP_CONTROL_CALSS_LV}>
        <span>顯示儀表板</span>
      </Button>
      <Button style={controlButtonStyle} onClick={handleOpenClose}>
        <span>即時資訊</span>
      </Button>
      <Button style={controlButtonStyle} onClick={ToHistory}>
        <span>異常歷史紀錄</span>
      </Button>
      <Button style={controlButtonStyle} onClick={ToSetting} hidden={user.class <= 2}>
        <span>管理設定</span>
      </Button>
      <Button style={controlButtonStyle} onClick={ToDashboardConfig} hidden={user.class != process.env.REACT_APP_CONTROL_CALSS_LV}>
        <span>儀表板設定</span>
      </Button>
      <Button style={controlButtonStyle} onClick={logOutOpen}>
        <span>登出</span>
      </Button>
    </div>
  );
}